import Api from "./api";
const getOneError = { 'type': 'fail', 'message': 'não foi possível pesquisar o Developer.' };

const ProvaService = {
    login: async (params) => {
        localStorage.removeItem('user', 'token');
        const response = await Api.post('/vestibular/login', params)
        localStorage.setItem('token', response.data);
    },
    inicio: (params) => Api.get(`/vestibular/inicio/${params}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }),
    gerarprova: async (params) => {
        try {
            const response = await Api.post(
                '/vestibular/gerarprova',
                params,
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            );

            if (response.status === 200) {
                return response;
            } else {
                return getOneError;
            }
        } catch (error) {
            if (error.response) {
                return { 'type': 'fail', 'message': error.response.data };
            } else {
                return getOneError;
            }
        }
    },
    loginhash: async (params) => {
        try {
            const response = await Api.post(
                '/vestibular/hash',
                params
            );

            if (response.status === 200) {
                localStorage.setItem('token', response.data);
                return response;
            } else {
                return getOneError;
            }
        } catch (error) {
            if (error.response) {
                return { 'type': 'fail', 'message': error.response.data };
            } else {
                return getOneError;
            }
        }
    },
    


    finalizarprova: (params) => Api.post(
        '/vestibular/finalizarprova',
        params,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
    ),
    prova: (params) => Api.get(`/vestibular/prova/${params}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }),
    questao: (prova, questao) => Api.get(`/vestibular/questao/${prova}/${questao}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }),
    responder: (params) => Api.put('/vestibular/responder', params, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }),
    dataatual: () => Api.get(
        '/dataatual'
    ),


}


export default ProvaService;